(function($) {

	/*
	 *  new_map
	 *
	 *  This function will render a Google Map onto the selected jQuery element
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$el (jQuery element)
	 *  @return	n/a
	 */

	function new_map( $el ) {
		
		// var
		var $markers = $el.find('.marker');
		
		// vars
		var args = {
			zoom		: 16,
			center		: new google.maps.LatLng(0, 0),
			mapTypeId	: google.maps.MapTypeId.ROADMAP
		};
		
		// create map	        	
		var map = new google.maps.Map( $el[0], args);
		
		// add a markers reference
		map.markers = [];
		
		// add markers
		$markers.each(function(){
	    	add_marker( $(this), map );
		});
		
		// center map
		center_map( map );
		
		// return
		return map;
	}

	/*
	 *  add_marker
	 *
	 *  This function will add a marker to the selected Google Map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$marker (jQuery element)
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function add_marker( $marker, map ) {

		// var
		var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

		var markerImage = new google.maps.MarkerImage(
			'/wp-content/themes/gaystraightalliance/dist/svg/map-marker.svg',
			new google.maps.Size(40, 38), // width, height
			new google.maps.Point(0, 0), // beginning of image
			new google.maps.Point(20, 19) // centerpoint
		);

		// create marker
		var marker = new google.maps.Marker({
			position	: latlng,
			map			: map,
			icon		: markerImage
		});

		// add to array
		map.markers.push( marker );

		// if marker contains HTML, add it to an infoWindow
		if( $marker.html() )
		{
			// create infowinfow
			marker.infoWindow = createInfoWindow($marker.html());

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function() {

				// close other windows
				for(var i = 0; i < map.markers.length; i++) {
					map.markers[i].infoWindow.close();
				}

				// open this window
				var position = marker.getPosition();

				//map.setCenter(new google.maps.LatLng(position.lat(), position.lng()));
				marker.infoWindow.open( map, marker );

			});
		}

	}

	/**
	 * create info window
	 */
	function createInfoWindow( html ) {
		// render infowindow
		var container = document.createElement('div');
		container.classList.add('infowindow');
		container.innerHTML = html;

		// set width
		var width = 400;
		if($(window).width() < 992) width = 300;

		// set data
		var infoWindow = new InfoBox({
			content: container,
			disableAutoPan: false,
			maxWidth: width,
			alignBottom: true,
			pixelOffset: new google.maps.Size(0, -10),
			closeBoxMargin: "",
			closeBoxURL: ""
		});

		return infoWindow;
	}	


	/*
	 *  center_map
	 *
	 *  This function will center the map, showing all markers attached to this map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function center_map( map ) {

		// vars
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each( map.markers, function( i, marker ){

			var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

			bounds.extend( latlng );

		});

		// only 1 marker?
		if( map.markers.length == 1 )
		{
			// set center of map
		    map.setCenter( bounds.getCenter() );
		    map.setZoom( 16 );
		}
		else
		{

			// fit to bounds
			map.fitBounds( bounds );

			// zoom out 1 step
			setTimeout(function(){
				map.setZoom(map.getZoom() -1);
			}, 100);
		}

	}

	/*
	 *  document ready
	 *
	 *  This function will render each map when the document is ready (page has loaded)
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	5.0.0
	 *
	 *  @param	n/a
	 *  @return	n/a
	 */
	// global var
	var map = null;

	$('.acf-map').each(function(){
		// create map
		map = new_map( $(this) );
	});

})(jQuery);
